import { createApi } from '@reduxjs/toolkit/query/react';

import { FixedOdds, RunnerFixedOdds } from '@api/types/fixedOdds';
import { TAG_FIXED_ODDS } from '@config/tags';
import { FIXED_ODDS } from '@config/urls';

import { baseQuery } from './baseQuery';

export type FixedOddsArgs = {
  date: string;
  racecourseCode: string;
  raceNumber: number;
};

export type FixedOddsResponse = {
  fixedOdds: FixedOdds;
};

export const fixedOddsApi = createApi({
  reducerPath: 'fixedOddsApi',
  tagTypes: [TAG_FIXED_ODDS],
  baseQuery,
  refetchOnFocus: true,
  endpoints: (builder) => ({
    getFixedOddsByDateRacecourseAndRaceNumber: builder.query<RunnerFixedOdds[], FixedOddsArgs>({
      query: ({ date, racecourseCode, raceNumber }) => ({
        url: `${FIXED_ODDS}/${date}/${racecourseCode}/${raceNumber}`,
      }),
      transformResponse: (response: FixedOdds[]): RunnerFixedOdds[] => {
        return response[0]?.runnerFixedOdds ?? [];
      },
    }),
  }),
});

export const { useGetFixedOddsByDateRacecourseAndRaceNumberQuery } = fixedOddsApi;
